import AxiosClient from "../AxiosClient";

// 臨時スケジュール更新Api
export const postSalesPurchaseTransferSearchInfoListAPI = (params) => {
  return AxiosClient.post("/api/salesPurchaseTransfer/searchInfoList", params);
}
